// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-container.folders{
  
}
.report-records-container.images.folders{
  height:auto;
}
/* .each-parent-container.folder{
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width:100%;
  gap:1rem;
} */
.date-record-container.folder{
  width:100%;
  border-bottom:1px solid rgb(192, 194, 199);
}
.date-record-container.folder span{
   font-weight: 600;
   font-size: medium;
}
/* .folders-main-container.folder{
  display:grid;
  grid-template-columns: repeat(5,1fr);
  gap:1rem;
  width:100%;
} */
.each-folder.folder{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width:100%;
  background-color: rgb(249, 249, 249);
  gap:0.5rem;
  padding:1rem;
  height:-moz-fit-content;
  height:fit-content;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
}
.bay-buttons-container.images.folders{
  background-color:white;
  border-bottom: none;
}
.folder-last-modified-icon-container.folder{
  display: flex;
  align-items: flex-start;
  width:100%;
  justify-content: space-between;
}
.reportpage-right-container{
    flex: 1 1;
    width: 100%;
    max-width:100%;
    max-height: 100vh; /* Set a maximum height */
    overflow:none
    
  }
  .mainCss-report{
    width: 85%;
    height:100vh;
    display:flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  
  .page-container{
    width:100vw;
    height:100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }
  .popup-icon-container.folder-sub{
    display: flex;
    align-items: center;
    justify-content: center;
    width:3rem;
    height:3rem;
    background-color: rgb(234, 241, 255);
    border-radius:50%;

  }
  .back-button{
    display: flex;
    background-color: transparent;
    border: none;
  }
  .defect-back-container{
    display: flex;
    align-items: center;
    justify-content: center;
    gap:0.5rem;

  }
  .report-records-container.images{
    width:100%;
    /* height:100%; */
    display: grid;
    grid-template-columns: repeat(5,1fr);
    gap:1rem;
    padding:1rem;
    overflow-y: scroll;
  }
  .each-report-record.images{
    display: flex;
    flex-direction: column;
    padding:1rem;
    align-items:center;
    border:1px solid rgb(224, 230, 238);
    width:100%;
    height:-moz-fit-content;
    height:fit-content;
    background-color: rgb(249, 249, 249);
    border-radius:8px;
    gap:0.5rem;
    /* justify-content: center; */
  }
  .images-selected-container{
    width:100%;
    position:absolute;
    bottom:0%;
    background-color: white;
    padding:1.5rem;
    display:flex;
    align-items: center;
    justify-content: flex-end;
    gap:1rem;
    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  }
  .images-selected-buttons{
    border-radius:27px;
    padding:0.5rem 1rem;
  }
  .demo-popup-footer-button-container{
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap:1rem;
  }
  .images-selected-buttons.cancel{
    border:1px solid rgb(51, 69, 157);
    color:rgb(51, 69, 157);
    background-color: white;
  }
  .images-selected-buttons.move{
    border:1px solid rgb(51, 69, 157);
    background-color:rgb(51, 69, 157);
    color: white;
  }
  .each-report-record.images.included{
    background-color: rgb(236, 242, 253);
  }


  .popup-container {
    z-index: 15;
  }
  
  .popup-container {
    display: none;
    flex-direction: column;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    /* border:1px solid rgb(215, 217, 218); */
    position: absolute;
    /* margin-top:30vh;
    margin-left:35vw; */
    top: 0;
    left: 0;
    z-index: 12;
    /* border-left:1px solid rgb(181, 181, 181);
    border-right:1px solid rgb(181, 181, 181); */
  }
  
  .popup-container.show {
    display: flex;
    /* Show the popup when the 'show' class is present */
    align-items: center;
    justify-content: center;
  }
  
  .popup-container-in {
    width: -moz-fit-content;
    width: fit-content;
    min-width: 35vw;
    /* height: 45vh; */
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: white;
    position: relative;
    gap: 0.5rem;
    border-radius: 0.25rem;
  }
  
  .attribute-popup-title {
    width: 100%;
    color: white;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.8rem 1rem;
    background-color: rgb(51, 69, 157);
    border-radius: 0.25rem;
  }
  
  .popup-close-button {
    outline: none;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: transparent;
    border: none;
    color:white;
  }
  
  .attribute-subtitle-container {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
  }
  
  .attribute-subtitle-container-in {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
  }
  .attribute-image-options-list{
    width:100%;
    display: flex;
    flex-direction: column;
    /* align-items: center; */
    gap:1rem;
  }
  .step1-div,
  .step2-div {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.25rem;
  }
  .calender-button span{
    padding :0.25rem 0.25rem 0.25rem 0.25rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .calender-button-in-image-container.images{
    width:-moz-fit-content;
    width:fit-content;
    padding:4px;
    display: flex;
    align-items: center;
    justify-content: center;
    height:100%;
    background-color: rgb(211, 185, 49);
  }
  .attribute-popup-content{
    width:100%;
    padding:1rem;
    gap:1rem;
    display:flex;
    flex-direction: column;
  }
  .calender-button.images.popup{
    width:100%;
  }
  
  @media screen and (max-width: 1536px) {

  .report-records-container.images{
    grid-template-columns: repeat(4,1fr);
  }
   
  }
  @media screen and (max-width: 1360px)  {
    .report-records-container.images{
      grid-template-columns: repeat(4,1fr);
    }
  }`, "",{"version":3,"sources":["webpack://./src/pages/folders/sub-main/SubMain.css"],"names":[],"mappings":"AAAA;;AAEA;AACA;EACE,WAAW;AACb;AACA;;;;;;GAMG;AACH;EACE,UAAU;EACV,0CAA0C;AAC5C;AACA;GACG,gBAAgB;GAChB,iBAAiB;AACpB;AACA;;;;;GAKG;AACH;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;EAC9B,UAAU;EACV,oCAAoC;EACpC,UAAU;EACV,YAAY;EACZ,uBAAkB;EAAlB,kBAAkB;EAClB,2CAA2C;AAC7C;AACA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,UAAU;EACV,8BAA8B;AAChC;AACA;IACI,SAAO;IACP,WAAW;IACX,cAAc;IACd,iBAAiB,EAAE,yBAAyB;IAC5C;;EAEF;EACA;IACE,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,WAAW;IACX,oCAAoC;IACpC,iBAAiB;;EAEnB;EACA;IACE,aAAa;IACb,6BAA6B;IAC7B,YAAY;EACd;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;;EAEZ;EACA;IACE,UAAU;IACV,iBAAiB;IACjB,aAAa;IACb,oCAAoC;IACpC,QAAQ;IACR,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,mCAAmC;IACnC,UAAU;IACV,uBAAkB;IAAlB,kBAAkB;IAClB,oCAAoC;IACpC,iBAAiB;IACjB,UAAU;IACV,6BAA6B;EAC/B;EACA;IACE,UAAU;IACV,iBAAiB;IACjB,SAAS;IACT,uBAAuB;IACvB,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,QAAQ;IACR,qDAAqD;EACvD;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,QAAQ;EACV;EACA;IACE,iCAAiC;IACjC,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,iCAAiC;IACjC,iCAAiC;IACjC,YAAY;EACd;EACA;IACE,oCAAoC;EACtC;;;EAGA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,oCAAoC;IACpC,wCAAwC;IACxC,yCAAyC;IACzC,kBAAkB;IAClB;uBACmB;IACnB,MAAM;IACN,OAAO;IACP,WAAW;IACX;gDAC4C;EAC9C;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,uBAAkB;IAAlB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,oBAAoB;IACpB,kCAAkC;IAClC,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,6BAA6B;IAC7B,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,WAAW;EACb;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;EACb;EACA;IACE,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,QAAQ;EACV;EACA;;IAEE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;EACd;EACA;IACE,wCAAwC;IACxC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,sBAAiB;IAAjB,iBAAiB;IACjB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,mCAAmC;EACrC;EACA;IACE,UAAU;IACV,YAAY;IACZ,QAAQ;IACR,YAAY;IACZ,sBAAsB;EACxB;EACA;IACE,UAAU;EACZ;;EAEA;;EAEA;IACE,oCAAoC;EACtC;;EAEA;EACA;IACE;MACE,oCAAoC;IACtC;EACF","sourcesContent":[".table-container.folders{\r\n  \r\n}\r\n.report-records-container.images.folders{\r\n  height:auto;\r\n}\r\n/* .each-parent-container.folder{\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  width:100%;\r\n  gap:1rem;\r\n} */\r\n.date-record-container.folder{\r\n  width:100%;\r\n  border-bottom:1px solid rgb(192, 194, 199);\r\n}\r\n.date-record-container.folder span{\r\n   font-weight: 600;\r\n   font-size: medium;\r\n}\r\n/* .folders-main-container.folder{\r\n  display:grid;\r\n  grid-template-columns: repeat(5,1fr);\r\n  gap:1rem;\r\n  width:100%;\r\n} */\r\n.each-folder.folder{\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  width:100%;\r\n  background-color: rgb(249, 249, 249);\r\n  gap:0.5rem;\r\n  padding:1rem;\r\n  height:fit-content;\r\n  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;\r\n}\r\n.bay-buttons-container.images.folders{\r\n  background-color:white;\r\n  border-bottom: none;\r\n}\r\n.folder-last-modified-icon-container.folder{\r\n  display: flex;\r\n  align-items: flex-start;\r\n  width:100%;\r\n  justify-content: space-between;\r\n}\r\n.reportpage-right-container{\r\n    flex: 1;\r\n    width: 100%;\r\n    max-width:100%;\r\n    max-height: 100vh; /* Set a maximum height */\r\n    overflow:none\r\n    \r\n  }\r\n  .mainCss-report{\r\n    width: 85%;\r\n    height:100vh;\r\n    display:flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n  \r\n  .page-container{\r\n    width:100vw;\r\n    height:100vh;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    overflow: hidden;\r\n  }\r\n  .popup-icon-container.folder-sub{\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width:3rem;\r\n    height:3rem;\r\n    background-color: rgb(234, 241, 255);\r\n    border-radius:50%;\r\n\r\n  }\r\n  .back-button{\r\n    display: flex;\r\n    background-color: transparent;\r\n    border: none;\r\n  }\r\n  .defect-back-container{\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap:0.5rem;\r\n\r\n  }\r\n  .report-records-container.images{\r\n    width:100%;\r\n    /* height:100%; */\r\n    display: grid;\r\n    grid-template-columns: repeat(5,1fr);\r\n    gap:1rem;\r\n    padding:1rem;\r\n    overflow-y: scroll;\r\n  }\r\n  .each-report-record.images{\r\n    display: flex;\r\n    flex-direction: column;\r\n    padding:1rem;\r\n    align-items:center;\r\n    border:1px solid rgb(224, 230, 238);\r\n    width:100%;\r\n    height:fit-content;\r\n    background-color: rgb(249, 249, 249);\r\n    border-radius:8px;\r\n    gap:0.5rem;\r\n    /* justify-content: center; */\r\n  }\r\n  .images-selected-container{\r\n    width:100%;\r\n    position:absolute;\r\n    bottom:0%;\r\n    background-color: white;\r\n    padding:1.5rem;\r\n    display:flex;\r\n    align-items: center;\r\n    justify-content: flex-end;\r\n    gap:1rem;\r\n    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;\r\n  }\r\n  .images-selected-buttons{\r\n    border-radius:27px;\r\n    padding:0.5rem 1rem;\r\n  }\r\n  .demo-popup-footer-button-container{\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: flex-end;\r\n    gap:1rem;\r\n  }\r\n  .images-selected-buttons.cancel{\r\n    border:1px solid rgb(51, 69, 157);\r\n    color:rgb(51, 69, 157);\r\n    background-color: white;\r\n  }\r\n  .images-selected-buttons.move{\r\n    border:1px solid rgb(51, 69, 157);\r\n    background-color:rgb(51, 69, 157);\r\n    color: white;\r\n  }\r\n  .each-report-record.images.included{\r\n    background-color: rgb(236, 242, 253);\r\n  }\r\n\r\n\r\n  .popup-container {\r\n    z-index: 15;\r\n  }\r\n  \r\n  .popup-container {\r\n    display: none;\r\n    flex-direction: column;\r\n    width: 100vw;\r\n    height: 100vh;\r\n    background-color: rgba(0, 0, 0, 0.5);\r\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n    /* border:1px solid rgb(215, 217, 218); */\r\n    position: absolute;\r\n    /* margin-top:30vh;\r\n    margin-left:35vw; */\r\n    top: 0;\r\n    left: 0;\r\n    z-index: 12;\r\n    /* border-left:1px solid rgb(181, 181, 181);\r\n    border-right:1px solid rgb(181, 181, 181); */\r\n  }\r\n  \r\n  .popup-container.show {\r\n    display: flex;\r\n    /* Show the popup when the 'show' class is present */\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n  \r\n  .popup-container-in {\r\n    width: fit-content;\r\n    min-width: 35vw;\r\n    /* height: 45vh; */\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background-color: white;\r\n    position: relative;\r\n    gap: 0.5rem;\r\n    border-radius: 0.25rem;\r\n  }\r\n  \r\n  .attribute-popup-title {\r\n    width: 100%;\r\n    color: white;\r\n    font-weight: 600;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 0.8rem 1rem;\r\n    background-color: rgb(51, 69, 157);\r\n    border-radius: 0.25rem;\r\n  }\r\n  \r\n  .popup-close-button {\r\n    outline: none;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background-color: transparent;\r\n    border: none;\r\n    color:white;\r\n  }\r\n  \r\n  .attribute-subtitle-container {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: flex-start;\r\n    width: 100%;\r\n  }\r\n  \r\n  .attribute-subtitle-container-in {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 0.5rem;\r\n  }\r\n  .attribute-image-options-list{\r\n    width:100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    /* align-items: center; */\r\n    gap:1rem;\r\n  }\r\n  .step1-div,\r\n  .step2-div {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 0.25rem;\r\n  }\r\n  .calender-button span{\r\n    padding :0.25rem 0.25rem 0.25rem 0.25rem;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n  .calender-button-in-image-container.images{\r\n    width:fit-content;\r\n    padding:4px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    height:100%;\r\n    background-color: rgb(211, 185, 49);\r\n  }\r\n  .attribute-popup-content{\r\n    width:100%;\r\n    padding:1rem;\r\n    gap:1rem;\r\n    display:flex;\r\n    flex-direction: column;\r\n  }\r\n  .calender-button.images.popup{\r\n    width:100%;\r\n  }\r\n  \r\n  @media screen and (max-width: 1536px) {\r\n\r\n  .report-records-container.images{\r\n    grid-template-columns: repeat(4,1fr);\r\n  }\r\n   \r\n  }\r\n  @media screen and (max-width: 1360px)  {\r\n    .report-records-container.images{\r\n      grid-template-columns: repeat(4,1fr);\r\n    }\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
